import React, { useState } from "react";
import { Btn, ToolTip } from "../../../../AbstractElements";
import { CommonButtonProps } from "../../../../Type/CommonComponant";
import { Disabled } from "../../../../Constant";

const CommonEdgeButton = ({ item, size, active, disabled,outline }: CommonButtonProps) => {
  const [buttonTooltip, setButttooltip] = useState(false);
  const buttonToggle = () => setButttooltip(!buttonTooltip);
  return (
    <>
      {disabled ? (
        <Btn color={item.color} disabled={disabled} outline={outline} className={`btn-pill ${item.className}`}>{Disabled}</Btn>
      ) : (
        <>
          <Btn color={item.color} id={`Tooltip-${item.id}`} size={size} active={active} disabled={disabled} outline={outline} className={`btn-pill ${item.className}`}>{item.btnText}</Btn>
          <ToolTip target={`Tooltip-${item.id}`} isOpen={buttonTooltip} toggle={buttonToggle} >{item.tooltipText}</ToolTip>
        </>
      )}
    </>
  );
};

export default CommonEdgeButton;
